<template>
    <button @click="reset()" type="button" class="btn btn-sm btn-success btn-block">
        <li class="fa fa-recycle"></li> HABILITAR BLOQUEIO IMEDIATO
    </button>
</template>
<script>
    import {Comandos} from '../../class';
    import {Bus} from '../../class/bus';
    export default {
        props: {
            id_rastreador: {
                "default": null
            }
        },
        methods: {
            async reset () {
                await Comandos.bloqueioImediato(this.id_rastreador, true);
                Bus.$emit('comandos');
            }
        }
    }
</script>
